import { auth } from '~config/firebase'
import { RecaptchaVerifier } from 'firebase/auth'
import { useRef, useEffect, useState } from 'react'

export function useRecaptcha(containerId: string): {
    recaptchaVerifier: RecaptchaVerifier | undefined
    resetVerifier: () => void
} {
    const [recaptchaVerifier, setRecaptchaVerifier] =
        useState<RecaptchaVerifier>()

    function setVerifier() {
        const verifier = new RecaptchaVerifier(auth, containerId, {
            size: 'invisible',
        })
        setRecaptchaVerifier(verifier)
    }

    function resetVerifier() {
        if (recaptchaVerifier) {
            recaptchaVerifier?.clear()
        }
        const container = document.getElementById(containerId)
        if (container) {
            container.outerHTML = `<div id="${containerId}"></div>`
            const newVerifier = new RecaptchaVerifier(auth, containerId, {
                size: 'invisible',
            })
            setRecaptchaVerifier(newVerifier)
        }
    }

    useEffect(() => {
        setVerifier()
    }, [])

    return {
        recaptchaVerifier,
        resetVerifier,
    }
}
